module.exports = __webpack_public_path__ + "ecb7ba8c96319548a4ecb0349b1550fe.pdf";